import { SupportedCurrency } from '@/@types/Enums/supported-currency';
import FlagOne from '@/assets/icons/FlagOne';
import FlagThree from '@/assets/icons/FlagThree';
import FlagTwo from '@/assets/icons/FlagTwo';
import MarkEmptyImg from '@/assets/icons/mark-empy.svg';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Card } from '../ui/card';

interface MarketCardProps {
  title: string;
  description: string;
  amount?: number;
  productId: string;
  index: number;
  isTopSelling: boolean;
  commissions?: Record<string, Array<{ commission?: { value_formatted?: string } }>>;
  images?: Array<{ url: string }>;
}

export default function MarketCard({
  title,
  description,
  amount,
  productId,
  index,
  isTopSelling,
  commissions,
  images,
}: MarketCardProps) {
  const renderFlag = () => {
    if (index === 0) return <FlagOne />;
    if (index === 1) return <FlagTwo />;
    if (index === 2) return <FlagThree />;
    return null;
  };

  const { t } = useTranslation('common');

  return (
    <Link to={`/marketplace/${productId}`}>
      <Card className='sm:min-w-[240px] lg:max-w-[293px] relative h-[470px] cursor-pointer hover:opacity-80 transition-shadow'>
        {isTopSelling && (
          <div className='absolute -top-2 left-0 z-10'>{renderFlag()}</div>
        )}
        <img
          src={images?.[0]?.url || MarkEmptyImg}
          alt={title || 'Produto sem imagem'}
          className='w-full object-cover h-[240px]'
        />
        <div className='p-4 flex flex-col bg-disabled justify-between gap-2 h-[230px]'>
          <article className='max-h-[110px] overflow-hidden'>
            <h3 className='text-sm font-medium truncate text-ellipsis line-clamp-2'>
              {title}
            </h3>
            <p
              className='text-sm text-muted-foreground mb-4 overflow-hidden'
              style={{
                maxHeight: 64,
                display: '-webkit-box',
                WebkitLineClamp: 4,
              }}
            >
              {description}
            </p>
          </article>
          <footer className='flex flex-col flex-shrink-0 mt-4'>
            <p className='text-muted text-xs'>{t('common:receiveUpTo')}</p>
            <div className='flex flex-col gap-2'>
              {Object.values(SupportedCurrency).every(
                (currency) =>
                  !commissions?.[currency] ||
                  !commissions?.[currency][0]?.commission?.value_formatted
              ) ? (
                <p className='text-base text-interactive font-medium'>
                  {t('common:noCommissionAvailable')}
                </p>
              ) : (
                <>
                  {Object.values(SupportedCurrency).map((currency) => {
                    const commission =
                      commissions?.[currency]?.[0]?.commission?.value_formatted;
                    return (
                      commission && (
                        <p
                          key={currency}
                          className='text-xl font-medium text-interactive'
                        >
                          {commission}
                        </p>
                      )
                    );
                  })}
                </>
              )}
            </div>
          </footer>
        </div>
      </Card>
    </Link>
  );
}
